import { type LinkTarget } from '@dfg/brahma-types';

export const downloadFile = async (
  downloadURL: string,
  fileName: string = `${new Date().getTime()}.pdf`
) => {
  try {
    const response = await fetch(downloadURL);
    const blob = await response.blob();

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);

    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export const redirectTo = (
  redirectionUrl: string,
  target: LinkTarget = '_self'
) => {
  try {
    if (typeof window !== 'undefined' && window?.open) {
      window?.open(redirectionUrl, target);
    }
  } catch (error) {
    console.error('Error in redirection to - ', redirectionUrl, error);
  }
};
